/* fk-local-pages.js — behaviour for the store pages and suburb delivery pages.

   Three jobs, all built on window.FK.StoreContext (fk-store-context.js), so the
   hours, cutoffs and ZIP lists stay the operator's theme settings and nothing
   here re-reads or re-guesses them:

   1. Cutoff lines. [data-fk-cutoff="austin"] elements show today's same-day
      order-by time, or the next delivery day once today's cutoff has passed or
      the shop is closed. Liquid renders a first-paint value; this keeps it right
      as the minute ticks over (fk:tick).
   2. ZIP check cards. [data-fk-zc="austin"] forms say whether same-day delivery
      reaches a ZIP and link to the right shelf. Messaging only, never a gate:
      an out-of-area ZIP always gets a way to buy.
   3. Store context. A page that is about one shop suggests that shop (never
      confirms it), the same signal the old store page sent.

   Loaded with defer after fk-store-context.js, and guarded so a second copy of
   the tag in the same page does nothing. */
(function () {
  if (window.__fkLocalPages) return;
  window.__fkLocalPages = true;

  function ctx() { return window.FK && window.FK.StoreContext; }

  function hourLabel(h) {
    var C = ctx();
    if (C && C.formatHour) return C.formatHour(h);
    var suffix = h >= 12 ? ' PM' : ' AM';
    var hr = h % 12 === 0 ? 12 : h % 12;
    return hr + suffix;
  }

  function cutoffParts(key) {
    var C = ctx();
    if (!C) return null;
    var s = C.status(key);
    if (!s || !s.known) return null;
    if (s.state !== 'closed' && !s.pastCutoff && s.cutoffHour != null) {
      return { today: true, time: hourLabel(s.cutoffHour) };
    }
    return { today: false, day: s.nextOpenDayName || 'tomorrow' };
  }

  function renderCutoffs() {
    document.querySelectorAll('[data-fk-cutoff]').forEach(function (el) {
      var p = cutoffParts(el.getAttribute('data-fk-cutoff'));
      if (!p) return;
      var short = el.getAttribute('data-fk-cutoff-format') === 'short';
      if (p.today) {
        el.innerHTML = short
          ? 'Order by ' + p.time + ' today'
          : 'Order by <strong>' + p.time + '</strong> for delivery today.';
      } else {
        el.innerHTML = short
          ? 'Order now for ' + p.day
          : 'Order now for delivery <strong>' + p.day + '</strong>.';
      }
    });
  }

  var CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9.5"></circle><path d="M8 12.5l2.7 2.7L16.2 9.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function readyFor(key) {
    var C = ctx();
    var store = C && C.getStore(key);
    return (store && store.readyUrl) || ('/collections/ready-' + key);
  }

  function runCheck(form) {
    var C = ctx();
    var pageKey = form.getAttribute('data-fk-zc');
    var input = form.querySelector('input');
    var out = form.parentNode.querySelector('[data-fk-zc-result]');
    if (!input || !out) return;

    var zip = String(input.value || '').replace(/\D/g, '').slice(0, 5);
    var msg = '';
    var link = '';
    var cls = 'fk-zc__result';

    var result = (C && zip.length === 5) ? C.zoneForZip(zip) : null;

    if (zip.length !== 5 || !result) {
      msg = 'Enter a 5-digit ZIP code.';
      cls += ' is-invalid';
    } else if (result.zone === 'delivery' && result.store === pageKey) {
      msg = CHECK + '<span>Good news, we deliver to ' + esc(zip) + '.</span>';
      link = '<a class="fk-zc__go" href="' + esc(readyFor(pageKey)) + '" data-fk-store-confirm="' + esc(pageKey) + '">Shop Now →</a>';
    } else if (result.zone === 'delivery') {
      var other = C.getStore(result.store);
      var city = (other && other.city) || result.store;
      msg = CHECK + '<span>Our ' + esc(city) + ' shop delivers to ' + esc(zip) + '.</span>';
      link = '<a class="fk-zc__go" href="' + esc(readyFor(result.store)) + '" data-fk-store-confirm="' + esc(result.store) + '">Shop ' + esc(city) + ' →</a>';
    } else {
      msg = '<span>Same-day delivery does not reach ' + esc(zip) + ' yet, but we ship anywhere in the US.</span>';
      link = '<a class="fk-zc__go" href="/collections/all">Shop everything →</a>';
      cls += ' is-national';
    }

    out.className = cls;
    out.innerHTML = '<span class="fk-zc__msg">' + msg + '</span>' + link;
    out.hidden = false;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-fk-zc]');
    if (!form) return;
    e.preventDefault();
    runCheck(form);
  });

  /* Monday-first week table. The shared renderer in fk-store-ui.js writes the
     hours Sunday-first because the settings are Sunday-indexed; this only moves
     the Sunday row to the end. No hours are read or recalculated here. */
  function mondayFirst() {
    document.querySelectorAll('[data-fk-loc-week]').forEach(function (table) {
      var body = table.tBodies && table.tBodies[0];
      if (!body || body.rows.length !== 7) return;
      if (body.getAttribute('data-fk-monday-first')) return;
      body.appendChild(body.rows[0]);
      body.setAttribute('data-fk-monday-first', '1');
    });
  }

  function suggestStore() {
    var C = ctx();
    var root = document.querySelector('[data-fk-local-store]');
    if (!C || !root) return;
    if (C.get() !== 'none') return;
    C.suggest(root.getAttribute('data-fk-local-store'));
  }

  /* Phone bar vs the Klaviyo teaser. Once the sign-up pop-up is closed,
     Klaviyo pins a small "15% off" teaser to the bottom of the screen, right
     where the Directions / Shop today bar sits. When that teaser is visible,
     lift the bar to sit just above it. When the teaser is gone (signed up,
     dismissed, or never shown), the lift goes back to 0. Klaviyo injects the
     teaser late and its class names are hashed, so this looks for any
     element whose class contains "kl-teaser" and checks again every second;
     the check is a single query and does nothing on pages without the bar. */
  function teaserLift() {
    var bar = document.querySelector('.fk-loc-actions');
    if (!bar || window.getComputedStyle(bar).display === 'none') return;
    var lift = 0;
    var vh = window.innerHeight;
    document.querySelectorAll('[class*="kl-teaser"]').forEach(function (t) {
      var cs = window.getComputedStyle(t);
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return;
      var r = t.getBoundingClientRect();
      if (r.width === 0 || r.height === 0) return;
      /* Only a teaser docked in the lower part of the screen matters. */
      if (r.top < vh * 0.6 || r.top > vh) return;
      lift = Math.max(lift, Math.ceil(vh - r.top) + 8);
    });
    var next = lift + 'px';
    var root = document.documentElement;
    if (root.style.getPropertyValue('--fk-loc-actions-lift') !== next) {
      root.style.setProperty('--fk-loc-actions-lift', next);
    }
  }

  function renderAll() {
    renderCutoffs();
    mondayFirst();
  }

  function boot() {
    suggestStore();
    renderAll();
    /* fk-store-ui.js renders the week table on its own boot and on every tick;
       run after it so the Sunday row ends up last. */
    window.setTimeout(mondayFirst, 0);
    if (document.querySelector('.fk-loc-actions')) {
      teaserLift();
      window.setInterval(teaserLift, 1000);
      window.addEventListener('resize', teaserLift);
    }
  }

  document.addEventListener('fk:tick', function () { renderAll(); window.setTimeout(mondayFirst, 0); });
  document.addEventListener('fk:store-context-changed', renderAll);
  document.addEventListener('shopify:section:load', renderAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
